import settings from "./settings/email.json";

/**
 * 
 * Sends an email to recipient(s) with a specified subject and body.
 * 
 * @param to, the recipient(s) email address if multiple separate with ","
 * @param subject, the subject of the email
 * @param body, the body of the email (content)
 * 
 * @returns boolean Whether or not the email was sent
 */
export async function sendEmail(from: string, to: string, subject: string, body: string, file?: File): Promise<boolean> {
    // This is a mock implementation of an email sending function.
    // In a real application, you would use an email service provider's API.

    const formData = new FormData();
    formData.append("subject", subject);
    formData.append("body", body);
    formData.append("to", to);
    formData.append("from", from);
    if (file) {
        formData.append("attachment", file);
    }

    try {
        await fetch(settings.routingWorker, {
            method: "POST",
            body: formData,
            headers: {
                // Don't manually set Content-Type when using FormData, fetch will handle it
                "Accept": "*/*",
                "User-Agent": "PostmanRuntime/7.44.1",
                "Accept-Encoding": "gzip, deflate, br",
                "Connection": "keep-alive"
            }
        });
        return true;
    } catch (error) {
        return false;
    }
}